import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import LabelInput from 'components/common/LabelInput';
import {changeUserName} from 'function/api';
import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {userInfoState} from 'utils/Atoms';
import {minmax} from 'utils/minmax';

type Props = {
  selectItem: any;
  closeModal: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
};

const ChangeUserNameModal = ({
  selectItem,
  closeModal,
  setIsLoading,
  setErrorModal,
}: Props) => {
  const userInfo = useRecoilValue(userInfoState);
  const [name, setName] = useState<string>('');
  const [confirmModal, setConfirmModal] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);

  useEffect(() => {
    if (selectItem) {
      setName(selectItem?.name || '');
    }
  }, [selectItem]);

  return (
    <>
      <CommonModal closeModal={closeModal}>
        <ModalContainer>
          <ModalHeader>
            <DefaultText
              text="사용자 이름 변경"
              textStyle={{fontSize: minmax(40)}}
            />
            <DefaultImageView
              source="images/common/close.png"
              onClick={closeModal}
              style={{
                width: minmax(30),
                height: minmax(30),
                margin: minmax(15),
                cursor: 'pointer',
              }}
            />
          </ModalHeader>

          <InfoRow>
            <DefaultText
              text={`UUID: ${selectItem?.userUUID || selectItem?.uuid || ''}`}
              textStyle={{fontSize: minmax(20), color: colors.darkGray}}
            />
          </InfoRow>

          <LabelInput
            type={'text'}
            labelText={'이름'}
            value={name}
            setValue={setName}
          />

          <DefaultButton
            text="change"
            actived={1}
            buttonStyle={{
              width: '100%',
              backgroundColor: colors.primary2,
            }}
            textStyle={{fontSize: minmax(25)}}
            onClick={() => {
              if (!name || !name.trim()) {
                setErrorModal({title: '입력 오류', detail: '이름을 입력해주세요.'});
                return;
              }
              setConfirmModal(true);
            }}
          />
        </ModalContainer>
      </CommonModal>
      {confirmModal && (
        <CommonModal
          title="이름 변경 확인"
          detail={`사용자 이름을 "${name.trim()}"(으)로 변경하시겠습니까?\n\n※ 결재선/확인 리스트/공지 등 대부분의 문서는 자동 동기화되지만, 일부 법정 문서(작업허가서의 작업책임자/현장책임자 등)에는 변경 전 이름이 그대로 남을 수 있습니다.`}
          firstButtonText="confirm"
          secondButtonText="cancel"
          firstButtonClick={async () => {
            setConfirmModal(false);
            const result = await changeUserName({
              userInfo,
              setIsLoading,
              setErrorModal,
              userUUID: selectItem?.userUUID || selectItem?.uuid,
              name: name.trim(),
            });
            if (result) setCompleteModal(true);
          }}
          secondButtonClick={() => setConfirmModal(false)}
          closeModal={() => setConfirmModal(false)}
        />
      )}
      {completeModal && (
        <CommonModal
          title="이름 변경 완료!"
          detail="사용자 이름이 변경되었습니다."
          firstButtonText="confirm"
          firstButtonClick={() => {
            closeModal();
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default ChangeUserNameModal;

const ModalContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${minmax(20)};
`;

const ModalHeader = styled.div`
  width: 100%;
  margin-bottom: ${minmax(10)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

const InfoRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
